

import React, { useState } from "react";
import "./App.css";
import TopImage from "./components/TopImage";
import LeftNav from "./components/LeftNav";
import Viewport from "./components/Viewport";
import { ethers } from "ethers";
import BottomCard from "./components/BottomCard";
import { useEffect } from "react";
import { EAGLEEYE_ADDRESS, NODE_URL } from "./assets/constants";
import EAGLEEYE_ABI from "./assets/EagleEyeABI.json";
import Web3Modal from "web3modal";
//@ts-ignore
import { CopyToClipboard } from "react-copy-to-clipboard";
// import detectProvider from '@metamask/detect-provider'
import {
  useUIProviderDispatch,
  useUIProviderState,
} from "./contexts/UIProvider";
//@ts-ignore
import WalletConnectProvider from "@walletconnect/web3-provider";

import {
  useWeb3ProviderDispatch,
  useWeb3ProviderState,
} from "./contexts/Web3Provider";
import { useMediaQuery } from "react-responsive";

async function initWeb3(web3Dispatch: any) {
  const provider = new ethers.providers.JsonRpcProvider(NODE_URL);

  const EagleEyeContract = new ethers.Contract(
    // DOBO_BNB_LP_ADDRESS,
    EAGLEEYE_ADDRESS,
    EAGLEEYE_ABI,
    provider
  );
  web3Dispatch({ type: "UPDATE_WEB3_PROVIDER", payload: provider });

  web3Dispatch({ type: "UPDATE_CURRENT_CONTRACT", payload: EagleEyeContract });
  const totalRewards = await EagleEyeContract.totalRewardBNBPaid();

  web3Dispatch({ type: "UPDATE_TOTAL_REWARDS", payload: totalRewards });
  const totalSupply = await EagleEyeContract.totalSupply();
  web3Dispatch({ type: "UPDATE_SUPPLY", payload: totalSupply.toString() });
  const tokensBurned = await EagleEyeContract.totalTokensBurned();
  web3Dispatch({ type: "UPDATE_TOTAL_BURNED", payload: tokensBurned });
  const tokensToBurn = await EagleEyeContract.tokensToBurn();
  web3Dispatch({ type: "UPDATE_TOKENS_TO_BURN", payload: tokensToBurn });
  const timeLeft = await EagleEyeContract.liquidityUnlockTimeLeft();
  web3Dispatch({ type: "UPDATE_TIME", payload: timeLeft.toString() });
  const taxes = await EagleEyeContract.allTaxes();
}

function App() {
  const web3State = useWeb3ProviderState();
  const web3Dispatch = useWeb3ProviderDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const [copied, setCopied] = useState(false);
  const [copyShowing, setCopyShowing] = useState(true);
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (copied === true) {
      timeout = setTimeout(() => {
        setCopied(false);
      }, 3500);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [copied]);
  const uiState = useUIProviderState();
  const uiDispatch = useUIProviderDispatch();
  useEffect(() => {
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          rpc: {
            "56": NODE_URL,
          },
          chainId: 56,
          supportedChainIds: [56],
          network: "binance",
          bridge: "https://bridge.walletconnect.org", // Required
        },
      },
    };
    const web3Modal = new Web3Modal({
      network: "mainnet", // optional
      cacheProvider: true, // optional
      providerOptions, // required
    });
    if (web3Modal.cachedProvider) {
      const provider = web3Modal.connect();
    }
    web3Modal.on("connect", async (provider) => {
      web3Dispatch({ type: "UPDATE_WALLET_PROVIDER", payload: provider });
      const accounts = await provider.request({ method: "eth_accounts" });
      web3Dispatch({ type: "UPDATE_CURRENT_WALLET", payload: accounts[0] });
    });
    if (web3Modal.cachedProvider) {
      // const accounts = await provider.request({method: 'eth_accounts'});
      // web3Dispatch({type: "UPDATE_CURRENT_WALLET", payload: accounts[0]})
    } else {
      // not cache
    }
    web3Dispatch({ type: "UPDATE_WEB3_MODAL", payload: web3Modal });
    initWeb3(web3Dispatch);
  }, []);

  function handleTouchingOutsideMenu() {
    if (uiState.menuShowing) {
      uiDispatch({ type: "TOGGLE_MENU_VISIBLE" });
    }
  }
  return (
    <div
      className={`container`}
      onTouchMove={handleTouchingOutsideMenu}
      onMouseDown={handleTouchingOutsideMenu}
    >
      {copyShowing && (
        <div
          className="fixed-address"
          style={copied ? { background: "green" } : {}}
        >
          <CopyToClipboard
            text={EAGLEEYE_ADDRESS}
            onCopy={() => setCopied(true)}
          >
            <div>
              <span>CONTRACT ADDRESS: {EAGLEEYE_ADDRESS}</span>
              <i className="fa fa-copy"></i>
              <i
                className="fa fa-times-circle"
                onClick={(e) => {
                  e.stopPropagation();
                  setCopyShowing(false);
                }}
              ></i>
            </div>
          </CopyToClipboard>
        </div>
      )}
      <div className="siteVertical">
        <TopImage />

        <div className="siteContent">
          <div className="mainModal">
            <LeftNav />
            <Viewport />
          </div>
          <div className={`leftNavBackground filterShadow`} />
          <div className={`rightViewportBackground filterShadow`} />
        </div>
        <div className="bottomBanner">
          <BottomCard>
            <div className="timerCard">
              <span className="cardTitle">LIQUIDITY UNLOCK TIMER</span>
              <span>{web3State.timeLeftHours} HOUR</span>
              <span>{web3State.timeLeftMinutes} MINUTE</span>
              <span>{web3State.timeLeftSeconds} SECONDS</span>
            </div>
          </BottomCard>
          <BottomCard>
            <div className="supply-card">
              <span style={{ color: "var(--text-header-red)" }}>
                CIRCULATING SUPPLY
              </span>
              <span
                style={{
                  fontSize: "1rem",
                  margin: "0 0 1rem 0",
                }}
              >
                (includes burned)
              </span>

              <span>{web3State.totalSupply}</span>
            </div>
          </BottomCard>
          <BottomCard>
            <div className="burn-card">
              <span style={{ color: "var(--text-header-red)" }}>
                BURN VAULT
              </span>
              <span>{web3State.tokensToBurn}</span>
              <span style={{ color: "var(--text-header-blue)" }}>
                TOTAL BURNED
              </span>
              <span>{web3State.tokensBurned}</span>
            </div>
          </BottomCard>
          <BottomCard>
            <div className="rewards-card">
              <span style={{ color: "var(--text-header-blue)" }}>
                TOTAL REWARDS PAYOUT
              </span>
              <span>{web3State.totalRewards} BNB</span>
            </div>
          </BottomCard>
        </div>
      </div>

      <footer></footer>
    </div>
  );
}

export default App;
